<template>
    <div class="Guard" v-show="show">
        <slot></slot>
    </div>
</template>

<script type="text/babel">

import FormInput from '../../Shared/UI/Form/FormInput.vue';
import { required, minLength, email } from 'vuelidate/lib/validators';
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
    name: 'Guard',
    data () {
        return {
            show: false,
            role: ''
        };
    },
    props: {
        'hideFor': {
            type: Array,
            default: function() { return [] }
        },
        'showFor': {
            type: Array,
            default: function() { return [] }
        }
    },
    computed: {
        ...mapGetters(['getUser'])
    },
    mounted() {
        this.checkUserRole();
        this.checkPermition();
    },
    methods: {
        checkUserRole() {
            const { role = undefined, context = undefined } = this.getUser;

            if(role === 'key_account' && context.length > 0) {
                this.role = "shop_owner"
            } else {
                this.role = role
            }
        },
        checkPermition() {
            this.show = true;

            this.hideFor && this.hideFor.forEach((role) => {
                if(role === this.role)
                    this.show = false;
            });

            if(this.hideFor.length === 0) this.show = false;

            this.showFor && this.showFor.forEach((role) => {
                if(role === this.role)
                    this.show = true;
            });
        }
    }
};
</script>
